export default __webpack_public_path__ + "static/media/bg-agent-0.25bc68ce.png";